import {NgModule} from '@angular/core';
import {ImSeverityIconDirective} from "./directive/im-severity-icon.directive";
import {ImDataImportComponent} from "./component/protected-components/im-data-import/im-data-import.component";
import {ImDashboardPage} from "./page/overview/im-dashboard/im-dashboard.page";
import {ImViewImportComponent} from "./component/protected-components/im-view-import/im-view-import.component";
import {ImImportPage} from "./page/overview/im-import/im-import.page";
import {BlockUIModule} from "primeng/blockui";
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {ImConfigPage} from "./page/overview/im-config/im-config.page";
import {ImOverviewPage} from "./page/im-overview-page/im-overview.page";
import {ImStatisticsComponent} from "./page/im-overview-page/components/statisticsComponent/im-statistics.component";
import {ImKpiComponent} from "./page/im-overview-page/components/kpiComponent/im-kpi.component";
import {
    ImTestComponent
} from "./component/protected-components/im-schema-object-component/view/shared/im-test-component/im-test.component";
import {
    ImSchemaFullComponent
} from "./component/protected-components/im-schema-object-component/view/full/im-schema-full.component";
import {
    ImSchemaSideComponent
} from "./component/protected-components/im-schema-object-component/view/side/im-schema-side.component";
import {
    ImSchemaObjectComponent
} from "./component/protected-components/im-schema-object-component/im-schema-object.component";
import {
    ImSchemaBaseComponent
} from "./component/protected-components/im-schema-object-component/view/im-schema-base.component";
import {EmModule} from "../em/em.module";
import {ImImportObjectComponent} from "./component/object-components/object-component/im-import-object.component";
import {
    ImImportObjectFullComponent
} from "./component/object-components/object-component/view/im-import-object-full-component/im-import-object-full.component";
import {
    ImImportObjectSideComponent
} from "./component/object-components/object-component/view/im-import-object-side-component/im-import-object-side.component";
import {
    ImImportObjectBaseComponent
} from "./component/object-components/object-component/view/im-import-object-base.component";
import {
    ImImportDataComponent
} from "./component/object-components/object-component/shared/im-import-data/im-import-data.component";
import {
    ImImportRecordComponent
} from "./component/object-components/object-component/shared/im-import-record/im-import-record.component";
import {BmModule} from "../../feature-bm/bm/bm.module";
import {IM_ENTITY_PROVIDER} from "./im.entity-provider";
import {CoreModule} from "../../core/core.module";
import {UiModule} from "../../core/ui/ui.module";
import {DynamicModule} from "../../core/shared/interface/dynamic-module.interface";
import {ModuleRegistryService} from "../../core/shared/interface/module-registration.service";
import {IM_TEST_PROVIDERS} from "./test/im-test-definition";
import {ImUploadPage} from "./page/overview/im-upload/im-upload.page";
import {
    ImUploadWizardComponent
} from "./component/protected-components/im-upload-wizard/im-upload-wizard.component";


@NgModule({
    declarations: [
        ImDataImportComponent,
        ImDashboardPage,
        ImViewImportComponent,
        ImImportPage,
        ImSeverityIconDirective,
        ImConfigPage,
        ImOverviewPage,
        ImStatisticsComponent,
        ImKpiComponent,
        ImTestComponent,
        ImSchemaFullComponent,
        ImSchemaSideComponent,
        ImSchemaObjectComponent,
        ImSchemaBaseComponent,
        ImImportObjectComponent,
        ImImportObjectFullComponent,
        ImImportObjectSideComponent,
        ImImportObjectBaseComponent,
        ImImportDataComponent,
        ImImportRecordComponent,
        ImUploadPage,
        ImUploadWizardComponent,
    ],
    exports: [
        ImDataImportComponent,
        ImDashboardPage,
        ImViewImportComponent,
        ImImportPage,
        ImSeverityIconDirective,
        ImConfigPage,
        ImSchemaFullComponent,
        ImSchemaSideComponent,
        ImSchemaObjectComponent,
        ImSchemaBaseComponent,
        ImTestComponent,
    ],
    imports: [
        CoreModule,
        UiModule,
        BlockUIModule,
        ProgressSpinnerModule,
        EmModule,
        BmModule
    ],
    providers: [IM_ENTITY_PROVIDER, IM_TEST_PROVIDERS]
})
export class ImModule implements DynamicModule {

    alias = 'im';

    constructor(private moduleRegistry: ModuleRegistryService) {
        this.moduleRegistry.registerModule(this);
    }

    getKpiComponent() {
        return ImKpiComponent;
    }

    getStatisticsComponent() {
        return ImStatisticsComponent;
    }
}
